import { createAction } from "redux-actions";

import { SET_LOYALTY_IS_INVITED } from "../constants";

const setLoyaltyIsInvited = createAction(SET_LOYALTY_IS_INVITED);

export default setLoyaltyIsInvited;
